import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { QueryOptions, useQuery, UseQueryResult } from '@tanstack/react-query'
import turfQualityApi, { ITurfQuality } from '@/api/config/turfQualityApi'

function useSearchTurfQuality(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<ITurfQuality>, any> {

  return useQuery(
    [queryKeys.turfQuality, interfaceId, searchParams],
    async () => {
      const { data } = await turfQualityApi.getAll({
        ...searchParams,
        interfaceId,
      })

      if (!data) return null

      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchTurfQuality
